import { render, staticRenderFns } from "./UserHours.vue?vue&type=template&id=071f4d2d"
import script from "./UserHours.vue?vue&type=script&lang=js"
export * from "./UserHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports